exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav.sidebar{padding:0!important;height:100%;min-height:94vh}nav.sidebar .el-menu-vertical-demo{height:100%;min-height:92vh}.nav-link{display:initial}.link:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65190756","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Sidebar.vue
// module id = RiGQ
// module chunks = 21